// Helpers puros de composição de payload do cadastro de negócio.
// Extraído de Cadastrar.js para eliminar duplicação (era usado em ambos
// os fluxos: submit final e criação de draft para uploads).

/**
 * Compõe o campo `endereco` (string única) a partir dos campos
 * separados do formulário (rua, número, complemento e — no caso rural —
 * também a comunidade). Ignora partes vazias.
 *
 * @param {object} form — objeto do wizard com `tipo_localizacao`,
 *                        `comunidade`, `rua`, `numero`, `complemento`.
 * @returns {string} — endereço em uma linha, ex.: "Amoras, Rua A, nº 5, Fundos".
 */
export const composeEndereco = (form) => {
  const parts = form.tipo_localizacao === 'comunidade_rural'
    ? [form.comunidade, form.rua, form.numero ? `nº ${form.numero}` : '', form.complemento]
    : [form.rua, form.numero ? `nº ${form.numero}` : '', form.complemento];
  return parts.filter(Boolean).join(', ');
};
